import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Menu, MenuItem, useMediaQuery } from "@mui/material";
import { ArrowDown2 } from "iconsax-react";
import React, { useState } from "react";
import useSwitchLanguage from "./useSwitchLanguage";
import { getLanguageDisplay, Language } from "./languageUtils";
export const SwitchLanguage = ({ buttonProps, ...rest }) => {
    const isLargeScreen = useMediaQuery("(min-width:900px)");
    const [selectedLanguage, setSelectedLanguage] = useState(Language.NL);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const handleMenuOpen = (event) => {
        setIsMenuOpen(true);
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setIsMenuOpen(false);
        setAnchorEl(null);
    };
    const language = rest.selectedLanguage || selectedLanguage;
    const { languages, renderFlagIcon } = useSwitchLanguage({
        selectedLanguage: language,
        setSelectedLanguage: rest.setSelectedLanguage ?? setSelectedLanguage,
        handleMenuClose: handleMenuClose,
    });
    return (_jsxs(React.Fragment, { children: [_jsx(Button, { variant: "outlined", sx: {
                    borderRadius: { xs: 1, lg: 2 },
                    backgroundColor: "#fff",
                }, style: {
                    background: buttonProps?.variant === "soft" ? "" : "white",
                }, color: "ePrimary", endIcon: _jsx(ArrowDown2, { size: "12px" }), onClick: handleMenuOpen, startIcon: renderFlagIcon(language), ...buttonProps, children: getLanguageDisplay(language, isLargeScreen) }), _jsx(LanguageMenu, { anchorEl: anchorEl, isOpen: isMenuOpen, languages: languages, onClose: handleMenuClose })] }));
};
export const LanguageMenu = ({ anchorEl, isOpen, onClose, languages, }) => {
    return (_jsx(Menu, { anchorEl: anchorEl, open: isOpen, onClose: onClose, anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
        }, transformOrigin: {
            vertical: "top",
            horizontal: "left",
        }, children: languages.map(({ src, alt, isDisabled, label, onClick }) => !isDisabled && (_jsxs(MenuItem, { onClick: (e) => {
                e.stopPropagation();
                onClick();
            }, children: [_jsx("img", { src: src, alt: alt, style: { width: 20, height: 15, marginRight: 8 } }), _jsx("span", { children: label })] }, label))) }));
};
